import { Zap, ChartNoAxesColumn, Star, Rewind, SquareCheckBig, Phone, Construction, Clipboard } from "lucide-react";

export const categoryConfig = {
  "Inmobiliarios y Urbanos": {
    heroImage:
      "https://images.unsplash.com/photo-1551711974-faf378be34b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3NTU5MjE3NzN8MA&ixlib=rb-4.1.0&q=85",
    heroTitle: "Trámites Inmobiliarios y Urbanos",
    heroSubtitle: "Expertos en Permisos de Construcción, Avalúos y Desarrollo Urbano",
    heroDescription: "Simplificamos todos tus trámites inmobiliarios con 15+ años de experiencia y 95% de éxito en aprobaciones.",
    stats: [
      { number: "500+", label: "Permisos Procesados", icon: <Construction className="text-yellow-500" style={{ scale: "2" }} /> },
      { number: "95%", label: "Tasa de Aprobación", icon: <SquareCheckBig className="text-yellow-500" style={{ scale: "2" }} /> },
      { number: "15+", label: "Años de Experiencia", icon: <Star className="text-yellow-500" style={{ scale: "2" }} /> },
      { number: "24/7", label: "Seguimiento", icon: <Rewind className="text-yellow-500" style={{ scale: "2" }} /> },
    ],
    benefits: [
      { title: "Experiencia Comprobada", description: "Más de 15 años gestionando trámites inmobiliarios exitosamente" },
      { title: "Proceso Transparente", description: "Seguimiento en tiempo real de cada paso de tu trámite" },
      { title: "Red de Contactos", description: "Relaciones directas con autoridades y dependencias gubernamentales" },
      { title: "Garantía de Servicio", description: "Si no obtienes tu permiso, te devolvemos tu dinero" },
    ],
    testimonials: [
      { name: "Ana García", company: "Constructora del Valle", text: "Excelente servicio, obtuvimos nuestro permiso de construcción en tiempo récord." },
      { name: "Carlos Mendoza", company: "Grupo Inmobiliario", text: "Profesionales y confiables. Nos ayudaron con todos los trámites catastrales." },
    ],
  },

  "Fiscales y Catastrales": {
    heroImage:
      "https://images.unsplash.com/photo-1712921855566-9631f61f47ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx0YXglMjBvZmZpY2UlMjBnb3Zlcm5tZW50JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzU1OTIyOTc5fDA&ixlib=rb-4.1.0&q=85",
    heroTitle: "Trámites Fiscales y Catastrales",
    heroSubtitle: "Expertos en SAT, SHCP y Declaraciones Fiscales",
    heroDescription: "Gestionamos tus obligaciones fiscales con 20+ años de experiencia y 98% de éxito en auditorías del SAT.",
    stats: [
      { number: "1000+", label: "Declaraciones Procesadas", icon: <ChartNoAxesColumn style={{ scale: "1.5" }} /> },
      { number: "98%", label: "Aprobación SAT", icon: <SquareCheckBig style={{ scale: "1.5" }} /> },
      { number: "20+", label: "Años de Experiencia", icon: <Star style={{ scale: "1.5" }} /> },
      { number: "24/7", label: "Asesoría Fiscal", icon: <Phone style={{ scale: "1.5" }} /> },
    ],
    benefits: [
      { title: "Conocimiento Fiscal Profundo", description: "Especialistas certificados en legislación fiscal mexicana actualizada" },
      { title: "Relación Directa con SAT", description: "Contactos especializados en todas las oficinas del SAT a nivel nacional" },
      { title: "Cumplimiento Garantizado", description: "Garantizamos el cumplimiento de todas tus obligaciones fiscales" },
      { title: "Asesoría Preventiva", description: "Te ayudamos a evitar multas y problemas con Hacienda" },
    ],
    testimonials: [
      { name: "María Rodríguez", company: "Contadora Pública", text: "Nos han ayudado con múltiples auditorías del SAT. Su conocimiento es excepcional." },
      { name: "Roberto Silva", company: "Empresario PYME", text: "Gracias a ellos nunca he tenido problemas fiscales. Muy recomendable su servicio." },
    ],
  },

  Vehiculares: {
    heroImage:
      "https://images.unsplash.com/photo-1747655760044-4b7ad66668c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHx2ZWhpY2xlJTIwb2ZmaWNlfGVufDB8fHx8MTc1NTkyMjk4OXww&ixlib=rb-4.1.0&q=85",
    heroTitle: "Trámites Vehiculares",
    heroSubtitle: "Especialistas en Placas, Licencias y Verificación Vehicular",
    heroDescription: "Tramitamos todos tus documentos vehiculares en 12+ estados con 99% de aprobación en verificaciones.",
    stats: [
      { number: "5000+", label: "Placas Tramitadas", icon: "🚗" },
      { number: "99%", label: "Verificaciones Aprobadas", icon: <SquareCheckBig style={{ scale: "1.5" }} /> },
      { number: "12+", label: "Estados Cubiertos", icon: "🗺️" },
      { number: "48h", label: "Entrega Express", icon: <Zap style={{ scale: "1.5" }} /> },
    ],
    benefits: [
      { title: "Red Nacional de Centros", description: "Alianzas con verificentros y oficinas de tránsito en toda la República" },
      { title: "Citas Garantizadas", description: "Agendamos tus citas sin filas ni esperas prolongadas" },
      { title: "Tramitación Express", description: "Entrega de placas y documentos en tiempo récord" },
      { title: "Verificación Certificada", description: "99% de aprobación en verificaciones vehiculares" },
    ],
    testimonials: [
      { name: "Luis Hernández", company: "Propietario Particular", text: "Obtuve mis placas nuevas en solo 2 días. Servicio increíble." },
      { name: "Patricia Morales", company: "Flotilla Comercial", text: "Manejan toda nuestra flotilla de 50 vehículos. Muy eficientes y confiables." },
    ],
  },

  Empresariales: {
    heroImage:
      "https://images.unsplash.com/photo-1745792820242-d5dcf7815967?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB0b3dlcnxlbnwwfHx8fDE3NTU5MjI5OTR8MA&ixlib=rb-4.1.0&q=85",
    heroTitle: "Trámites Empresariales",
    heroSubtitle: "Especialistas en Constitución, Permisos y Registros Mercantiles",
    heroDescription: "Constituimos y formalizamos tu empresa con 15+ años de experiencia y red de 25+ notarías certificadas.",
    stats: [
      { number: "800+", label: "Empresas Constituidas", icon: "🏢" },
      { number: "95%", label: "En Tiempo Récord", icon: <Zap style={{ scale: "1.5" }} /> },
      { number: "25+", label: "Notarías Aliadas", icon: <Clipboard style={{ scale: "1.5" }} /> },
      { number: "100%", label: "Asesoría Legal Incluida", icon: "⚖️" },
    ],
    benefits: [
      { title: "Asesoría Legal Integral", description: "Abogados corporativos especializados en derecho mercantil mexicano" },
      { title: "Red de Notarios Certificados", description: "Acceso directo a 25+ notarías públicas en toda la República" },
      { title: "Proceso Acelerado", description: "Constituye tu empresa en tiempo récord con todos los permisos" },
      { title: "Seguimiento Personalizado", description: "Un ejecutivo dedicado para cada proyecto empresarial" },
    ],
    testimonials: [
      { name: "Andrea Gutiérrez", company: "Fundadora Startup", text: "Constituí mi empresa tech en solo 5 días. Servicio excepcional y asesoría de primera." },
      { name: "Miguel Ángel Torres", company: "Director Corporativo", text: "Nos ayudaron con la expansión a México. Su conocimiento legal es impresionante." },
    ],
  },

  "Servicios Públicos y Pagos": {
    heroImage:
      "https://images.unsplash.com/photo-1666259912056-b54e0e9df7bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwdWJsaWMlMjB1dGlsaXRpZXN8ZW58MHx8fHwxNzU1OTIzMjA5fDA&ixlib=rb-4.1.0&q=85",
    heroTitle: "Servicios Públicos y Pagos",
    heroSubtitle: "Expertos en CFE, SACMEX y Servicios de Agua y Electricidad",
    heroDescription: "Gestionamos todos tus servicios públicos con 2000+ contratos procesados y 100% de servicios activados exitosamente.",
    stats: [
      { number: "2000+", label: "Contratos Procesados", icon: <Zap style={{ scale: 2 }} /> },
      { number: "100%", label: "Servicios Activados", icon: <SquareCheckBig style={{ scale: 2 }} /> },
      { number: "24h", label: "Atención Continua", icon: "🕐" },
      { number: "32", label: "Estados Cubiertos", icon: "🗺️" },
    ],
    benefits: [
      { title: "Gestión Directa CFE/SACMEX", description: "Relación directa con oficinas de CFE y SACMEX en toda la República" },
      { title: "Citas Prioritarias", description: "Agenda preferencial sin filas ni esperas prolongadas" },
      { title: "Pagos Incluidos", description: "Manejamos todos los pagos y depósitos requeridos" },
      { title: "Activación Garantizada", description: "100% de éxito en activación de servicios de luz y agua" },
    ],
    testimonials: [
      { name: "Carmen López", company: "Propietaria Residencial", text: "Activaron mi servicio de luz en mi casa nueva en solo 3 días. Excelente servicio." },
      { name: "Rafael Jiménez", company: "Gerente Comercial", text: "Manejan todos los servicios de nuestros 15 locales comerciales. Muy eficientes." },
    ],
  },

  "Personales y Familiares": {
    heroImage:
      "https://images.unsplash.com/photo-1556011302-64f47124a8fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxnb3Zlcm5tZW50JTIwc2VydmljZXN8ZW58MHx8fHwxNzU1OTIzMjE0fDA&ixlib=rb-4.1.0&q=85",
    heroTitle: "Trámites Personales y Familiares",
    heroSubtitle: "Especialistas en CURP, Actas, Apostillas y Poderes Notariales",
    heroDescription: "Tramitamos todos tus documentos personales con red nacional de registros civiles y 100% apostillas certificadas.",
    stats: [
      { number: "10000+", label: "Actas Tramitadas", icon: "📜" },
      { number: "100%", label: "Apostillas Certificadas", icon: "🌍" },
      { number: "50+", label: "Registros Civiles", icon: "🏛️" },
      { number: "72h", label: "Entrega Express", icon: "<Zap />" },
    ],
    benefits: [
      { title: "Red Nacional de Registros", description: "Acceso a 50+ registros civiles en toda la República Mexicana" },
      { title: "Apostilla Internacional", description: "Certificación internacional válida en 100+ países del mundo" },
      { title: "Asesoría Legal Familiar", description: "Abogados especializados en derecho familiar y civil" },
      { title: "Entrega Personalizada", description: "Entregamos tus documentos donde los necesites" },
    ],
    testimonials: [
      { name: "Isabel Moreno", company: "Madre de Familia", text: "Obtuvieron las actas de nacimiento de mis hijos para el trámite de pasaporte. Rapidísimo." },
      { name: "Estudiante García", company: "Estudiante Internacional", text: "Apostillaron mis documentos para estudiar en España. Proceso impecable." },
    ],
  },

  "Migratorios y Extranjería": {
    heroImage:
      "https://images.unsplash.com/photo-1713540161756-c0db69f472da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxpbW1pZ3JhdGlvbiUyMHNlcnZpY2VzfGVufDB8fHx8MTc1NTkyMzIyNHww&ixlib=rb-4.1.0&q=85",
    heroTitle: "Trámites Migratorios y Extranjería",
    heroSubtitle: "Especialistas en Visas, Residencias y Naturalización Mexicana",
    heroDescription: "Procesamos todos tus trámites migratorios con 500+ visas aprobadas y 95% de residencias exitosas certificadas por INM.",
    stats: [
      { number: "500+", label: "Visas Aprobadas", icon: "✈️" },
      { number: "95%", label: "Residencias Exitosas", icon: "🏠" },
      { number: "INM", label: "Certificados", icon: "🛂" },
      { number: "60+", label: "Países Atendidos", icon: "🌍" },
    ],
    benefits: [
      { title: "Abogados Migratorios Certificados", description: "Especialistas certificados en derecho migratorio mexicano e internacional" },
      { title: "Seguimiento Directo con INM", description: "Relación directa con Instituto Nacional de Migración" },
      { title: "Asesoría Internacional", description: "Conocimiento de leyes migratorias de 60+ países" },
      { title: "Proceso Integral", description: "Desde turista hasta ciudadano mexicano, cubrimos todo el proceso" },
    ],
    testimonials: [
      { name: "James Wilson", company: "Empresario Americano", text: "Me ayudaron a obtener mi residencia permanente en México. Proceso súper profesional." },
      { name: "Sofia Chen", company: "Inversionista China", text: "Excelente asesoría para mi visa de inversionista. Ahora tengo mi empresa en México." },
    ],
  },
};

export const getCategoryConfig = (categoryName) => {
  return categoryConfig[categoryName] || null;
};

export const getDefaultConfig = (categoryName) => ({
  heroImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
  heroTitle: categoryName,
  heroSubtitle: "Servicios Profesionales Especializados",
  heroDescription: "Te ayudamos con todos tus trámites de manera rápida, segura y profesional.",
  stats: [
    { number: "100+", label: "Trámites Procesados", icon: <Clipboard style={{ scale: "2" }} /> },
    { number: "90%", label: "Tasa de Éxito", icon: <SquareCheckBig style={{ scale: "2" }} /> },
    { number: "10+", label: "Años de Experiencia", icon: <Star style={{ scale: "2" }} /> },
    { number: "24/7", label: "Seguimiento", icon: <Rewind style={{ scale: "2" }} /> },
  ],
  benefits: [
    { title: "Experiencia Profesional", description: "Años de experiencia en trámites gubernamentales" },
    { title: "Seguimiento Total", description: "Monitoreo completo de tu proceso" },
    { title: "Soporte Completo", description: "Asesoría personalizada en cada paso" },
    { title: "Garantía", description: "Respaldamos nuestro trabajo" },
  ],
  testimonials: [{ name: "Cliente Satisfecho", company: "Empresa Local", text: "Excelente servicio y atención profesional." }],
});
